var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHojaAmarilla(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 185,
    height: 107,
    viewBox: "0 0 185 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.665448 55.5431L85.9434 98.8833C118.471 115.421 158.265 102.462 174.818 69.9164L184.468 50.9253L99.1724 7.57048C66.6452 -8.96728 26.8507 3.99224 10.2983 36.5375L0.647572 55.5285L0.665448 55.5431Z",
    fill: "#DFA41A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHojaAmarilla);
export default __webpack_public_path__ + "static/media/hoja_amarilla.9db05bb2990af195f8b3c4a0039cf8c5.svg";
export { ForwardRef as ReactComponent };